import { createIcon } from './createIcon';

const Sort = createIcon(
  'Sort',
  <>
    <path
      d="M3 9L7 5M7 5L11 9M7 5V19"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 15L17 19M17 19L13 15M17 19V5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
);

export default Sort;
